import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserInfo } from 'src/app/user/user-management/models/user.model';

@Component({
  selector: 'app-user-list-dialog',
  templateUrl: './user-list-dialog.component.html',
  styleUrls: ['./user-list-dialog.component.scss']
})
export class UserListDialogComponent implements OnInit {
  userInfoList: UserInfo[] = [];
  constructor(
    private dialogRef: MatDialogRef<UserListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.userInfoList = data.userInfoList;
  }

  ngOnInit(): void {

  }

  onUserSelected(userInfo: UserInfo) {
    this.dialogRef.close(userInfo);
  }

}
